import { useEffect } from 'react';
import * as L from 'leaflet';
import { useMapStore } from '../MapStore/UseMapStore';
import {
  handleItemClick,
  handlePlaceHover,
  handlePopupAndMenuOverlap,
} from '../MapFunctions/MapHelperFunctions';

export function usePlacesLayer() {
  const placeFC = useMapStore((s) => s.placeFC);
  const placeLayer = useMapStore((s) => s.placeLayer);
  const setPlaceRefLayer = useMapStore((s) => s.setPlaceRefLayer);
  const showInfo = useMapStore((s) => s.showInfo);
  const setSelected = useMapStore((s) => s.setSelected);
  const setClickEvent = useMapStore((s) => s.setClickEvent);
  const setShowInfo = useMapStore((s) => s.setShowInfo);
  const setShowMore = useMapStore((s) => s.setShowMore);

  useEffect(() => {
    console.log('places effect', {
      hasLayer: !!placeLayer,
      layerOnLiveMap: !!(placeLayer as any)?._map?._container?.isConnected,
      features: placeFC?.features?.length ?? null,
      mapSize: useMapStore.getState().mapInstance?.getSize?.(),
    });
    if (!placeLayer) return;

    placeLayer.clearLayers();
    setPlaceRefLayer(null);

    if (!placeFC || !placeFC.features.length) return;

    // Sort places by area (largest first)
    const sortedPlaces = placeFC.features.slice().sort((a, b) => {
      const areaB = L.GeometryUtil.geodesicArea(
        L.polygon((b.geometry as GeoJSON.Polygon).coordinates[0]).getLatLngs()[0],
      );
      const areaA = L.GeometryUtil.geodesicArea(
        L.polygon((a.geometry as GeoJSON.Polygon).coordinates[0]).getLatLngs()[0],
      );
      return areaB - areaA;
    });

    const newRef: Record<string, L.Layer> = {};
    const geoLayer = new L.GeoJSON(sortedPlaces, {
      onEachFeature(feature, layer) {
        handleItemClick(
          feature,
          layer,
          'place',
          showInfo,
          setSelected,
          handlePopupAndMenuOverlap,
          setClickEvent,
          setShowInfo,
          setShowMore,
        );
        handlePlaceHover(layer);
      },
      style: (feature) => ({
        color: feature.properties.BoundaryColor || 'var(--c-primary)',
        fillColor: '#ffffff00',
        weight: 2,
        opacity: 1,
      }),
    });

    geoLayer.eachLayer((layer) => {
      layer.bringToFront();
      newRef[layer.feature.properties.Id] = layer;
      placeLayer.addLayer(layer);
    });

    setPlaceRefLayer(newRef);
  }, [
    placeFC,
    placeLayer,
    showInfo,
    setSelected,
    setClickEvent,
    setShowInfo,
    setShowMore,
    setPlaceRefLayer,
  ]);
}
